import { apiClient } from './api';
import type { InsiderTrade, InsiderTradesResponse } from '../types/insiderTrades';

export interface FetchInsiderTradesParams {
  page?: number;
  perPage?: number;
  ticker?: string;
  transactionType?: string;
  search?: string;
}

interface PortalMeta {
  page: number;
  page_size: number;
  total_count: number;
  total_pages: number;
}

export const insiderTradesService = {
  async fetchTrades(params: FetchInsiderTradesParams = {}): Promise<InsiderTradesResponse> {
    const { page = 1, perPage = 20, ticker, transactionType, search } = params;
    const queryParams = new URLSearchParams({
      page: String(page),
      per_page: String(perPage),
    });
    if (ticker) queryParams.set('ticker', ticker);
    if (transactionType) queryParams.set('transaction_type', transactionType);
    if (search) queryParams.set('search', search);

    const result = await apiClient.get<{ data: InsiderTrade[]; meta: PortalMeta }>(
      `/api/market-data/insider-trades/?${queryParams}`
    );

    return {
      results: result.data ?? [],
      count: result.meta.total_count,
      page: result.meta.page,
      per_page: result.meta.page_size,
      total_pages: result.meta.total_pages,
    };
  },
};
